// extracted by mini-css-extract-plugin
export default {"container":"admin-lab-composers_container__0fjIt"};